export const pageConfig = {
  "title": "سوالات متداول",
  "suptitle": "که شاید شما هم داشته باشید"
}

export type PageConfig = typeof pageConfig
